import BaseService from "../base";
import ApplyForJbStepService from "./applyForJbStepService";
class ApplyForJbService extends BaseService {
  jbStatusSubmitForApproval = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("jbStatusSubmitForApproval", para, success, error);
  };

  getApplyJBStatusStepItem = (
    para: any,
    success: any,
    error: any,
    interfaceList: any,
    mergePayloadMap: any
  ) => {
    ApplyForJbStepService.getStepData(para, success, error, interfaceList, mergePayloadMap);
  };

  applyJBStatusTriggerStepAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("applyJBStatusTriggerStepAction", para, success, error);
  };

  checkApplyJBStatusSubmit = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("checkApplyJBStatusSubmit", para, success, error, returnPara);
  };

  getFlowStepData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getFlowStepData", para, success, error);
  };
}

const applyForJbService = new ApplyForJbService();

export default applyForJbService;
